import { createFileRoute } from '@tanstack/react-router';

import { PartnersListView } from '../../../features/partners/partners-list';

export const Route = createFileRoute('/admin/partners/')({
  component: PartnersListView,
});
